























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { IBlock } from "@/interfaces";

@Component({
  computed: {
    ...mapGetters("ui", ["nightMode"]),
  },
})
export default class NotFound extends Vue {
  @Prop({ required: true }) public isLoading: boolean;
  @Prop({ required: true }) public dataType: string;
  @Prop({ required: true }) public dataId: string;

  private emitReload() {
    this.$emit("reload");
  }
}
